import { SanityFormSection } from 'graphql-types';
import React from 'react';
import PlacesAutocomplete, { geocodeByPlaceId } from 'react-places-autocomplete';
import { findTranslation } from '../../utils/findTranslation';
import { useMapContext } from '../context/mapContext';
import { usePageContext } from '../context/pageContext';
import * as styles from './AutoComplete.module.scss';

interface Props {
  isLoaded: boolean;
  section: SanityFormSection;
  setAddressObject: any;
  addressObject: object;
}

export const AutoComplete: React.FC<Props> = ({
  isLoaded,
  section,
  setAddressObject,
  addressObject,
}) => {
  const { filterInput, setFilterInput } = useMapContext();
  const { lang, defaultLang } = usePageContext();

  const handleAutoCompleteChange = (value) => {
    setFilterInput(value);
    setAddressObject({
      ...addressObject,
      address: value,
    });
  };

  const handleSelect = (value: string, placeId: string, suggestion?: object) => {
    setFilterInput(value);
    geocodeByPlaceId(placeId)
      .then((results) => {
        const addressObjectsList = results?.[0]?.address_components;
        const currentObjectAddress = {
          zipCode: '',
          country: '',
          address: '',
        };

        currentObjectAddress.address = value;
        for (const element of addressObjectsList) {
          if (element.types.includes('country')) {
            currentObjectAddress.country = element.long_name;
          }
          if (element.types.includes('postal_code')) {
            currentObjectAddress.zipCode = element.short_name;
          }
        }

        setAddressObject({
          ...addressObject,
          zipCode: currentObjectAddress.zipCode,
          country: currentObjectAddress.country,
          address: currentObjectAddress.address,
        });
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className={styles.wrapper}>
      <form
        name="filterForm"
        method="post"
        onSubmit={(e: any) => {
          e.preventDefault();
        }}
      >
        <label>{findTranslation(section?._rawFormAddressSection, lang, defaultLang)}</label>
        {isLoaded && (
          // @ts-ignore
          <PlacesAutocomplete
            value={filterInput}
            onChange={(value) => handleAutoCompleteChange(value)}
            onSelect={handleSelect}
            debounce={400}
            shouldFetchSuggestions={filterInput.length > 3}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
              return (
                <div>
                  <div className={styles.input}>
                    <input
                      {...getInputProps({
                        placeholder:
                          findTranslation(
                            section?._rawFormPlaceholderAddressSection,
                            lang,
                            defaultLang,
                          ) ?? '',
                        type: 'text',
                      })}
                    />
                  </div>
                  <div className={styles.autocompleteDropdownContainer}>
                    {suggestions.map((suggestion, index) => {
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion)}
                          className={styles.suggestion}
                          key={`suggestion-${index}`}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }}
          </PlacesAutocomplete>
        )}
      </form>
    </div>
  );
};
